import cx from "classnames";
import { MediaType } from "shared-types";
import { useTranslation } from "i18n";
import { ImageWithFallback } from "component-library";
import { PlayIcon, VolumeHighIcon, CameraIcon } from "assets";
import getImageAltText from "pages/Profile/utils/getImageAltText";
import { MediaItem } from "pages/Profile/types";

const iconStyles =
  "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 drop-shadow-profile text-white";

interface Props {
  media: MediaItem;
}

export const MediaThumbnailPreview = ({ media }: Props) => {
  const { t } = useTranslation();

  if (media.isTranscodeError) {
    const ErrorIcon =
      media.mediaType === MediaType.Video ? CameraIcon : VolumeHighIcon;

    return (
      <ErrorIcon
        height={16}
        width={16}
        className={cx(iconStyles, "opacity-50")}
      />
    );
  }

  if (media.mediaType === MediaType.Video && media.poster) {
    return (
      <>
        <ImageWithFallback
          src={media.poster}
          alt={getImageAltText({
            t,
            description: media.title,
          })}
          loading="eager"
          className="h-full w-full rounded object-cover"
        />
        <PlayIcon height={16} width={16} className={iconStyles} />
      </>
    );
  }

  return <VolumeHighIcon height={16} width={16} className={iconStyles} />;
};

export default MediaThumbnailPreview;
